(function () {

    'use-strict';

    angular
        .module('jotApp')
        .directive('typesMapping', TypesMapping);

    TypesMapping.$inject = [];

    function TypesMapping()
    {
        var directive = {
            restrict: 'E',
            scope: {
                type: '='
            },
            template: '<div class="{{vm.styleSelect}}">' +
                      '<label class="control-label" translate="jotApp.tabObjectTypes.mapping.propertyDataType" for="field_data_type">Field Data Type</label>' +
                      '<ui-select ng-model="vm.selectedType" id="field_data_type" theme="bootstrap" ng-change="vm.changeFieldDataType()" ng-required="true">\n' +
                      '     <ui-select-match placeholder="Select a field data type...">\n' +
                      '          {{$select.selected.name}}\n' +
                      '     </ui-select-match>\n' +
                      '     <ui-select-choices group-by="vm.parent" repeat="item in vm.elasticTypes | propsFilter: {name: $select.search, description: $select.search}">\n' +
                      '          <div ng-bind-html="item.name | highlight: $select.search"></div>\n' +
                      '          <small ng-bind-html="item.description | highlight: $select.search"></small>\n' +
                      '     </ui-select-choices>\n' +
                      '</ui-select>\n' +
                      '</div>\n' +
                      '<div class="{{vm.styleSelect}}" ng-if="vm.showType">' +
                      '<label class="control-label" translate="jotApp.tabObjectTypes.mapping.propertyType" for="field_type">Type</label>' +
                      '<ui-select ng-model="vm.selectedValue" id="field_type" theme="bootstrap" ng-change="vm.changeType()" ng-required="true">\n' +
                      '     <ui-select-match placeholder="Select a type...">\n' +
                      '          {{$select.selected}}\n' +
                      '     </ui-select-match>\n' +
                      '     <ui-select-choices repeat="type in vm.value | filter: $select.search">\n' +
                      '          <div ng-bind-html="type | highlight: $select.search"></div>\n' +
                      '     </ui-select-choices>\n' +
                      '</ui-select>\n' +
                     '</div>' +
                     '<div class="{{vm.styleSelect}}" ng-if="vm.showDateFormat">\n' +
                     '      <label translate="jotApp.tabObjectTypes.mapping.formatDate" for="field_format">Format (Optional)</label>\n' +
                     '      <input type="text" class="form-control" id="field_format" ng-model="vm.format" placeholder="yyyy-MM-ddTHH:mm:ssZ" ng-change="vm.updateFormat()">' +
                     '</div>',
            controller: TypesMappingDirectiveController,
            controllerAs: 'vm',
            bindToController: true
        };
        return directive;
    }

    TypesMappingDirectiveController.$inject = [];

    function TypesMappingDirectiveController() {
        var vm = this;

        vm.type = "";
        vm.selectedType = [];
        vm.styleSelect = 'col-md-12 col-xs-12';
        vm.showType = false;
        vm.value = [];
        vm.selectedValue = "";

        vm.showDateFormat = false;
        vm.format = "";

        vm.elasticTypes = [];

        vm.elasticTypes.push({parent: "Core data types", name: "string", description: "text, keyword", value: ["text", "keyword"]});
        vm.elasticTypes.push({parent: "Core data types", name: "Numeric", description: "long, integer, short, byte, double, float, half_float, scaled_float", value: ["long", "integer", "short", "byte", "double", "float", "half_float", "scaled_float"]});
        vm.elasticTypes.push({parent: "Core data types", name: "Date", description: "date", value: ["date"]});
        vm.elasticTypes.push({parent: "Core data types", name: "Date nanoseconds", description: "date_nanos", value: ["date_nanos"]});
        vm.elasticTypes.push({parent: "Core data types", name: "Boolean", description: "boolean", value: ["boolean"]});
        vm.elasticTypes.push({parent: "Core data types", name: "Binary", description: "binary", value: ["binary"]});
        vm.elasticTypes.push({parent: "Core data types", name: "Range", description: "integer_range, float_range, long_range, double_range, date_range, ip_range", value: ["integer_range", "float_range", "long_range", "double_range", "date_range", "ip_range"]});

        vm.elasticTypes.push({parent: "Complex data types", name: "Object", description: "object for single JSON objects", value: ["object"]});
        vm.elasticTypes.push({parent: "Complex data types", name: "Nested", description: "nested for arrays of JSON objects", value: ["nested"]});

        vm.elasticTypes.push({parent: "Geo data types", name: "Geo-point", description: "geo_point for lat/lon points", value: ["geo_point"]});
        vm.elasticTypes.push({parent: "Geo data types", name: "Geo-shape", description: "geo_shape for complex shapes like polygons", value: ["geo_shape"]});

        vm.elasticTypes.push({parent: "Specialised data types", name: "IP", description: "ip for IPv4 and IPv6 addresses", value: ["ip"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Completion data type", description: "completion to provide auto-complete suggestions", value: ["completion"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Token count", description: "token_count to count the number of tokens in a string", value: ["token_count"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "mapper-murmur3", description: "murmur3 to compute hashes of values at index-time and store them in the index", value: ["murmur3"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "mapper-annotated-text", description: "annotated-text to index text containing special markup (typically used for identifying named entities)", value: ["annotated-text"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Percolator", description: "Accepts queries from the query-dsl", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Join", description: "Defines parent/child relation for documents within the same index", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Rank feature", description: "Record numeric feature to boost hits at query time.", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Rank features", description: "Record numeric features to boost hits at query time.", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Dense vector", description: "Record dense vectors of float values.", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Sparse vector", description: "Record sparse vectors of float values.", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Search-as-you-type", description: "A text-like field optimized for queries to implement as-you-type completion", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Alias", description: "Defines an alias to an existing field.", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Flattened", description: "Allows an entire JSON object to be indexed as a single field.", value: null});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Shape", description: "shape for arbitrary cartesian geometries.", value: ["shape"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Histogram", description: "histogram for pre-aggregated numerical values for percentiles aggregations.", value: ["histogram"]});
        vm.elasticTypes.push({parent: "Specialised data types", name: "Constant keyword", description: "Specialization of keyword for the case when all documents have the same value.", value: ["keyword"]});

        vm.parent = function(item) {
            return item.parent;
        };

        vm.changeFieldDataType = function() {
            vm.value = [];
            vm.selectedValue = "";
            vm.showDateFormat = false;
            vm.format = "";
            vm.styleSelect = cssClassType();
            vm.value = vm.selectedType.value;
            if(vm.value.length == 1){
                vm.selectedValue = vm.value[0];
                vm.changeType();
            }
        };

        function cssClassType() {
            if(vm.selectedType != null && vm.selectedType != undefined){
                if(vm.selectedType.value.length > 1 && vm.selectedType.value != null){
                    vm.showType = true;
                    return 'col-md-6 col-xs-12'
                }
            }
            vm.showType = false;
            return 'col-md-12 col-xs-12'
        }

        vm.changeType = function() {
            vm.type = vm.selectedValue;
            if(vm.type === "date"){
                vm.showDateFormat = true;
                vm.styleSelect = 'col-md-6 col-xs-12';
            }
        };

        vm.updateFormat = function() {
            vm.type = vm.type.substring(0, 4);
            vm.type += " (" + vm.format + ")";
        };
    }

})();
